export const pageSize = 20;
export const infinitePageSize = 50;
export const showingDistance = 6;
export const allQuestionsPageSize = 1000;
